<template>
  <hr class="cv-toolbar-divider bx--toolbar-menu__divider" />
</template>

<script>
export default {
  name: 'CvToolbarDivider',
};
</script>
